function SectionCandidateSkills() {
    return (
        <>
            <h4 className="twm-s-title">Skills</h4>
            <div className="tw-sidebar-tags-wrap">
                <div className="tagcloud">
                    <a href="#">Experimentation</a>
                    <a href="#">Simulation</a>
                    <a href="#">Problem-solving</a>
                    <a href="#">Classroom-management</a>
                    <a href="#">Communication</a>
                    <a href="#">Technology-integration</a>
                    {/* <a href="#">Developer</a>
                    <a href="#">Work from home</a>
                    <a href="#">IT Consulting</a>
                    <a href="#">Manufacturing</a> */}
                </div>
            </div>
        </>
    )
}

export default SectionCandidateSkills;